module.exports = __webpack_public_path__ + "static/media/logo-squared-500px.36adbf39.png";